import { hasLoggedInCookie } from '@helsenorge/framework-utils/cookie';
import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';
import { getHelsenorgeUrl, getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';
/**
 * Returnerer url prefixet med tjenestedomenet dersom linken er til en tjenesteside og bruker er pålogget
 * Hvis bruker ikke er pålogget, prefixes url med helsenorge-domenet. Dersom url ikke er til en tjeneste, gjøres ingen endringer.
 * @param link Link fra content-api-respons
 * @returns absolutt url med riktig domene
 */
export const getAbsoluteUrl = (link) => {
    const userIsLoggedIn = isAuthorized() || hasLoggedInCookie();
    if (link.tjenesteRelativeUrl && (userIsLoggedIn || link.redirectToTjenester)) {
        return getTjenesterUrl() + link.tjenesteRelativeUrl;
    }
    return link.href;
};
/**
 * Returnerer url prefixet med tjenestedomenet eller helsenorgedomenet, avhengig av om linken er relativ og bruker er pålogget eller ikke.
 * @param link relativ eller absolutt lenke
 */
export const convertToDomainLink = (link) => {
    const userIsLoggedIn = isAuthorized() || hasLoggedInCookie();
    const isRelativeLink = link.startsWith('/');
    if (userIsLoggedIn && isRelativeLink) {
        return getTjenesterUrl() + link;
    }
    if (!userIsLoggedIn && isRelativeLink) {
        return getHelsenorgeUrl() + link;
    }
    return link;
};
